import React from 'react';
import './nav.css'
import Logo from '../common/logo';
import Navbtn from './navbtn';

const Nav = (props) => {
    return ( 

            <nav>
                <Logo />
                <ul>
                    <Navbtn link="/" page="Home" />
                    <Navbtn link="/about" page="About Us" />
                    <Navbtn link="/tickets" page="TravelExpo Cairo 2026" />
                    <Navbtn link="/events" page="Events" />
                    <Navbtn link="/contact" page="Contact Us" />
                </ul>
            </nav>

     );
}
 
export default Nav;